
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/full-truck-load",
      function () {
        return require("private-next-pages/web/full-truck-load.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/full-truck-load"])
      });
    }
  